<template>
  <div
    class="gallery__item bg-light"
    :class="{ 'selected': (selected + 1) > 0 }">
    <a href="#" class="gallery__title" @click.prevent="selectImage" v-if="!disabled">
      <span v-if="isDevelopment">{{ data.assetId }}</span>&nbsp;
      <div
        class="kt-badge kt-badge--brand bg-danger gallery__counter"
        v-if="(selected + 1) > 0">{{ selected + 1 }}</div>
    </a>
    <div class="gallery__image">
      <a href="#" v-if="!disabled">
        <BaseImage
          class="rounded-left"
          :image="data.thumbnail" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ImagePickerImageGridItem',
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Number,
      default: -1
    }
  },
  computed: {
    ...mapState(['isDevelopment'])
  },
  methods: {
    selectImage () {
      const imageSelected = this.data
      this.$emit('onSelectImage', imageSelected)
    }
  }
}
</script>

<style lang="scss" scoped>
.gallery__item {
  position: relative;
  min-height: 100px;
  min-width: 100px;
  display: flex;
  align-items: center;
  transition: all .5s;
}
.gallery__image {
  line-height: 0;
  overflow: hidden;
}
.gallery__image img {
  transform: scale(1.1);
  width: 100%;
  height: auto;
}
.gallery__title {
  font-size: 1.5em;
  text-decoration: none;
  z-index: 1;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity .5s;
  background: rgba(255,255,255,0.2);
  color: white;

  /* position the text in t’ middle*/
  display: flex;
  align-items: center;
  justify-content: center;
}

.gallery__item:hover {
  transform: scale(0.95);
}

.gallery__item.selected .gallery__title,
.gallery__item:hover .gallery__title {
  opacity: 1;
  background: rgba(32, 111, 145, 0.35);
  background: -webkit-gradient(linear, left top, right top, from(rgba(32, 111, 145, 0.35)), color-stop(24%, rgba(45, 111, 143, 0.35)), color-stop(38%, rgba(91, 120, 160, 0.35)), color-stop(48%, rgba(114, 119, 146, 0.35)), color-stop(61%, rgba(127, 116, 137, 0.35)), color-stop(71%, rgba(157, 105, 110, 0.35)), color-stop(95%, rgba(193, 50, 62, 0.35)));
  background: linear-gradient(90deg, rgba(32, 111, 145, 0.35) 0%, rgba(45, 111, 143, 0.35) 24%, rgba(91, 120, 160, 0.35) 38%, rgba(114, 119, 146, 0.35) 48%, rgba(127, 116, 137, 0.35) 61%, rgba(157, 105, 110, 0.35) 71%, rgba(193, 50, 62, 0.35) 95%);
  z-index:999;
}

.gallery__item.selected .gallery__title {
  box-shadow: inset 0px 0px 0px 3px #c1323e;
}
.gallery__item.selected .gallery__counter {
  position: absolute;
  top: -6px;
  right: -6px;
  font-weight: 700;
  font-size: 1rem;
  height: 20px;
  width: 20px;
}
</style>
